var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#44d62c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,3.06A12.94,12.94,0,1,0,28.94,16,12.95,12.95,0,0,0,16,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.46,12.34a5.59,5.59,0,0,1-1.59.44,2.81,2.81,0,0,0,1.22-1.53,5.68,5.68,0,0,1-1.76.67,2.77,2.77,0,0,0-4.79,1.89,3.2,3.2,0,0,0,.07.63,7.8,7.8,0,0,1-5.7-2.89,2.76,2.76,0,0,0-.38,1.39,2.79,2.79,0,0,0,1.23,2.31,2.78,2.78,0,0,1-1.25-.35v0a2.76,2.76,0,0,0,2.22,2.71,2.52,2.52,0,0,1-.73.1,3,3,0,0,1-.52-.05,2.76,2.76,0,0,0,2.59,1.92,5.58,5.58,0,0,1-3.44,1.19c-.23,0-.45,0-.66,0a7.88,7.88,0,0,0,12.12-6.64c0-.12,0-.24,0-.35a5.56,5.56,0,0,0,1.38-1.44"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.991caa5f81fb29441a7956367c45896a.svg";
export { ForwardRef as ReactComponent };